import React, { Fragment, useState } from "react";
import { string, func, arrayOf, bool, node, oneOfType } from "prop-types";

const TextFieldGroup = ({
  inputId = "",
  inputName = "",
  placeholder = "",
  value,
  type = "text",
  onChange,
  classes,
  inputWidth = "",
  dontDisplayErrorMessage = false,
  onlyShowValidationAfterChange = false,
  validationMessageIsRed = false,
  validationMessages = [],
  isBold = false,
  defaultValue,
  isDisabled = false,
  onBlur,
  onKeyPress,
}) => {
  const [hasChanged, setHasChanged] = useState(false);

  const selfOnChange = (...args) => {
    setHasChanged(true);
    onChange(...args);
  };
  const isInvalid = validationMessages.length > 0;

  const showInvalid =
    (!onlyShowValidationAfterChange ||
      (onlyShowValidationAfterChange && hasChanged)) &&
    isInvalid;

  const validationMessage = isInvalid ? validationMessages[0] : "";
  return (
    <Fragment>
      <input
        id={inputId}
        name={inputName}
        type={type}
        className={`${classes || ""} form-control`}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        onChange={selfOnChange}
        onKeyPress={onKeyPress}
        onBlur={onBlur}
        disabled={isDisabled}
        style={{
          border: showInvalid ? "1px solid red" : "",
          fontWeight: isBold ? "bold" : "",
          width: inputWidth,
        }}
      />
      {showInvalid && !dontDisplayErrorMessage && (
        <span
          className="text_invalid fontSize-12"
          style={{
            color: validationMessageIsRed ? "red" : "black",
          }}
        >
          {validationMessage}
        </span>
      )}
    </Fragment>
  );
};

TextFieldGroup.propTypes = {
  inputId: string,
  inputName: string,
  placeholder: string,
  value: string.isRequired,
  type: string,
  onChange: func.isRequired,
  classes: string,
  dontDisplayErrorMessage: bool,
  validationMessageIsRed: bool,
  onlyShowValidationAfterChange: bool,
  validationMessages: oneOfType([arrayOf(node), string, bool]),
  isBold: bool,
  defaultValue: string,
  isDisabled: bool,
  onBlur: func,
  inputWidth: string,
};

export default TextFieldGroup;
